export const calcurateRadian = (angle) => angle * (Math.PI / 180);

export const calculateVertexCoordinate = (circleCenterCoordinate, radius, radianTheta, score) => {
  return ([
    Math.cos(radianTheta) * (radius * (score / 100)) + circleCenterCoordinate[0],
    Math.sin(radianTheta) * (radius * (score / 100)) + circleCenterCoordinate[1]
  ]);
};
